import * as React from 'react';
import { memo } from 'react';

import { warn } from 'helper/debug';

export type ImageSourcesetRendition = {
	media: string;
	x1?: string;
	x2?: string;
};

export type ImageSourceset = {
	renditions?: ImageSourcesetRendition[];
	fallback: {
		x1: string;
		x2: string;
	};
};

export type ImageProps = {
	srcset: ImageSourceset;
	alt: string;
	original?: string;
	title?: string;
	disableLazyLoading?: boolean;
	modifier?: string;
};

const Image = ({ srcset, alt, title, disableLazyLoading = false, modifier }: ImageProps) => {
	if (!srcset || !srcset.fallback) {
		warn(`The image could not be loaded. Property "srcset" is undefined`);
		return null;
	}

	const pictureClasses = ['a-image', 'js-a-image'];
	if (modifier) {
		pictureClasses.push(`a-image--${modifier}`);
	}

	const id = `${alt || title}`.replace(/ /g, '_').toUpperCase();

	const getRenditionString = (renditions: ImageSourcesetRendition[]): string => {
		const result: string[] = [];
		renditions.forEach((rendition: ImageSourcesetRendition) => {
			if (rendition.x1) {
				result.push(`${rendition.x1} ${rendition.media}w`);
			}
		});
		return result.join(', ');
	};

	return (
		<div className={pictureClasses.join(' ')}>
			<img
				key={`$.image-${id}`}
				className={`a-image__image${disableLazyLoading ? '' : ' lazyload'}`}
				data-sizes="auto"
				src={`${srcset.fallback.x1}`}
				srcSet={`data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==`}
				data-srcset={getRenditionString(srcset.renditions || [])}
				alt={alt}
				title={title}
			/>
		</div>
	);
};

export { Image };
export default memo(Image);
